import { Skeleton } from '@mui/material';

const style = {
    padding: 20,
    backgroundColor: '#fff',
    height: '80vh',
};

// eslint-disable-next-line no-unused-vars
export const SkeletonLoader = () => (
    <div className="skeleton-loader" style={style}>
        <Skeleton
            variant="rounded"
            width="40%"
            height={18}
            sx={{
                marginBottom: 2,
            }}
        />
        <Skeleton variant="rounded" width="50%" height={30} />
    </div>
);
